import { Col, Image, Row, Stack } from 'react-bootstrap';
import AbsoluteLogoMobile from 'assets/images/WithoutLogin/absolute-logo-phone.svg';
import { useContext, useEffect, useRef, useState } from 'react';
import ArrowBack from 'assets/images/WithoutLogin/arrow-left.svg';
import { useNavigate } from 'react-router-dom';
import { getContractFileCallAPI } from 'store/getContractFile/getContractFileAction';
import CommonToast from 'components/commom/CommonToast';
import { useDispatch, useSelector } from 'react-redux';
import { LocaleContext } from 'routes/Router';
import { Document, Page, pdfjs } from 'react-pdf';
import ReusableButton from 'components/commom/Button';
import { FormattedMessage } from 'react-intl';
import CommonModal from 'components/commom/Modal';
import SignatureCanvas from 'react-signature-canvas';
import { addContractFileCallAPI } from 'store/addContractFile/addContractFileAction';
import { registerFinal } from 'routes/AppUrls';

const RegistrationStepThree = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const { showToast } = CommonToast();
  const sigCanvas = useRef(null);

  const [numPages, setNumPages] = useState(null);
  const [isModal, setIsModal] = useState(false);

  const reviewData = useSelector(
    (state) => state?.getReviewDetailReducer?.users?.data
  );
  const contractData = useSelector(
    (state) => state?.getContractFileReducer?.users?.data
  );
  const contractLoader = useSelector(
    (state) => state?.addContractFileReducer?.loading
  );

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

  useEffect(() => {
    getConsentList();
  }, []);

  const getConsentList = () => {
    let title_id = reviewData?.title?.id;

    if (reviewData?.title?.id === 25) {
      title_id = 9;
    }

    const external = {
      run: true,
      handleFunction: (res) => {},
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getContractFileCallAPI(external, title_id));
  };

  const handleContinueWithSign = () => {
    setIsModal(true);
  };

  const handleDone = () => {
    if (!sigCanvas.current.isEmpty()) {
      const dataURL = sigCanvas.current.getCanvas().toDataURL('image/png');
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([ab], { type: mimeString });

      const Data = new FormData();
      Data.append('doctor_id', reviewData?.id);
      Data.append('signature', blob);
      Data.append('request_id', reviewData?.request_info?.request_id);

      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          navigate(registerFinal(locale));
        },
        error: true,
        handleErrorFunction: (res) => showToast(res?.message, 'error'),
      };

      dispatch(addContractFileCallAPI(Data, external));
    } else {
      showToast('No signature entered.', 'error');
    }
  };

  return (
    <Row className="m-0 p-0 landing-image">
      <Row className="mb-4 pt-80 size-padding flex justify-center">
        <Col
          xs={12}
          sm={10}
          md={10}
          lg={10}
          xl={10}
          xxl={10}
          className="bg-gray-100 sm:bg-light-100 m-0 p-0"
        >
          <div class="p-16 sm:p-32">
            <div className="d-flex">
              <div className="d-flex" onClick={() => navigate(-1)}>
                <Image
                  src={ArrowBack}
                  alt={'icon'}
                  className="cursor-pointer"
                />
              </div>
              <div className="main-heading pl-8 family_outfit_semiBold_600">
                Registration
              </div>
            </div>
            <Row className="m-0 p-0">
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="m-0 p-0 d-none d-sm-flex"
              >
                <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                  Step 3/4
                </p>
              </Col>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="m-0 p-0 d-none d-sm-flex"
              >
                <p className="pt-04 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                  {reviewData?.title?.id === 10
                    ? 'Aesthetician Membership Agreement'
                    : 'Contract Agreement'}
                </p>
              </Col>
              <div className=" m-0 p-0 d-flex d-sm-none justify-content-between">
                <div>
                  <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                    Step 3/4
                  </p>
                  <p className="pt-04 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                    Contract Details
                  </p>
                </div>
                <div className="d-flex align-items-center mt-4">
                  <Image src={AbsoluteLogoMobile} alt={'icon'} />
                </div>
              </div>
              <Col
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                xxl={12}
                className="m-0 p-0 "
              >
                <div
                  className="mt-4 d-flex justify-content-center"
                  style={{
                    height: '65vh', // Fixed height
                    width: '100%',
                    overflowY: 'auto', // Enable vertical scroll
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    background: 'white',
                    padding: '8px',
                  }}
                >
                  <Document
                    file={contractData && contractData[0]?.contract_url}
                    loading={<div>Loading PDF...</div>}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                  >
                    <div style={{}}>
                      {Array.from(new Array(numPages), (el, index) => (
                        <div
                          key={`page_${index + 1}`}
                          style={{
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            marginTop: '24px',
                            background: 'white',
                            padding: '8px',
                          }}
                        >
                          <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            renderMode="canvas"
                            renderTextLayer={false}
                            renderAnnotationLayer={false}
                          />
                        </div>
                      ))}
                    </div>
                  </Document>
                </div>
              </Col>
            </Row>
            <Row className="flex justify-end pt-48 sm:pt-32">
              <Col
                xs={12}
                sm={4}
                md={2}
                lg={2}
                xl={2}
                xxl={2}
                className="pt-16 sm-pt-0"
              >
                <ReusableButton
                  fullWidth={true}
                  variant="outlined"
                  color="#F5F5F5"
                  fontSize="18px"
                  fontWeight="600"
                  padding="12px 20px"
                  height="44px"
                  bgColor="#375241"
                  brColor="#375241  "
                  fontFamily="outfit_semiBold"
                  onClick={() => handleContinueWithSign()}
                >
                  <FormattedMessage id="Continue with e-sign" />
                </ReusableButton>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <CommonModal
        padding={'24px'}
        width={'700px'}
        modalActive={isModal}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Signature
                  </p>
                </div>
                <div className="border border-[#ccc] rounded-[8px] mt-4">
                  <SignatureCanvas
                    ref={sigCanvas}
                    canvasProps={{
                      className: 'w-full h-[250px]',
                    }}
                  />
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  gap={2}
                  className="items-sm-center justify-content-sm-end p-0 flex-column flex-sm-row"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => setIsModal(false)}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      sigCanvas.current.clear();
                    }}
                    // loading={registerReducer}
                  >
                    <FormattedMessage id="Clear" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      !contractLoader && handleDone();
                    }}
                    loading={contractLoader}
                  >
                    <FormattedMessage id="Done" />
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
    </Row>
  );
};

export default RegistrationStepThree;
